// RESONATE_SCROLL_TO_TOP_V1
// React Router keeps the scroll position across SPA navigations, so following
// a link near the bottom of one route (e.g. "See all questions" at the foot of
// the homepage FAQ) lands the next route at that same deep scroll offset -
// which read as a blank page opened near its bottom. Reset to the top on every
// pathname change, except when a hash is present (HashScrollFix owns anchor
// scrolling). useLayoutEffect runs before paint so there's no visible jump.
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};
